// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_g3-6";
export var emphasizeQuantity = "_g3-3";
export var flatBottomCorners = "_g3-5";
export var productImage = "_g3-0";
export var quantityContainer = "_g3-2";
export var tooltip = "_g3-1";
export var wrapAndEllipsesOverflow = "_g3-4";